<script>
import Nav from "@/components/Nav/index.vue";
import { nextTick } from "vue";
import axios from "axios";
export default {
    name: "Binding",
    data() {
        return {
            nowStep: "personalInfo",
            inputData: {
                gender: "",
                otp: "",
                otp1: "",
                otp2: "",
                otp3: "",
                otp4: "",
                otp5: "",
                email: "",
                name: ''
            },
            minutes: 3,
            seconds: 0,
            timerArr: [],
            isLock: false,
            isWrong: false,
            isBind: false,
            error03: false,
            maxDate: '',
            isMember: false,
            birthdayLock: false
        };
    },
    components: {
        Nav,
    },
    computed: {
        userNbInfo() {
            return this.$store.state.userNbInfo;
        },
        userLineInfo() {
            return this.$store.state.userLineInfo;
        },
        hostUrl() {
            return this.$store.state.hostUrl;
        },
    },
    watch: {
        userNbInfo: function () {
            let vm = this;
            if (vm.userNbInfo.data.user.isBind) {
                vm.$router.push("/");
            }
        },
        nowStep: function (newV) {
            const _this = this;
            _this.isBind = false;
            _this.isWrong = false;
            _this.isLock = false;
            if (newV === "messageOTP") {
                _this.$nextTick(() => {
                    window.scrollTo(0, 0);
                });
            }
        },
    },
    mounted() {
        nextTick(() => {});
        const today = new Date()
        const format = d => d.toISOString().split('T')[0]
        this.maxDate = format(today)
    },
    methods: {
        // checkOTP(e) {
        //     console.log("checkOTP", e.target.value);
        //     const input = e.target;
        //     const value = input.value;
        //     const validNum = /^\d{1}$/;

        //     if (value.length === Number(input.getAttribute("maxLength"))) {
        //         if (!validNum.test(value)) {
        //             input.value = "";
        //         } else {
        //             const nextInput =
        //                 input.parentElement.nextElementSibling?.firstElementChild;
        //             if (nextInput) {
        //                 nextInput.focus();
        //             }
        //         }
        //     }
        // },
        checkOTP(e, index) {
            const value = e.target.value;
            const keys = ["otp1", "otp2", "otp3", "otp4", "otp5"];

            // 🔹 情況 1：OTP 自動帶入（一次進來 5 碼）
            if (value.length > 1) {
                const digits = value.replace(/\D/g, "").slice(0, 5).split("");

                digits.forEach((num, i) => {
                    this.inputData[keys[i]] = num;
                });

                this.$nextTick(() => {
                    const lastInput = document.querySelector(`#otp${digits.length}`);
                    lastInput && lastInput.focus();
                });

                return;
            }

            // 🔹 情況 2：手動輸入
            if (!/^\d$/.test(value)) {
                this.inputData[keys[index]] = "";
                return;
            }

            // 自動跳下一格
            if (index < 4) {
                const next = document.querySelector(`#otp${index + 2}`);
                next && next.focus();
            }
        },
        onOtpBackspace(index) {
            const keys = ["otp1", "otp2", "otp3", "otp4", "otp5"];

            if (this.inputData[keys[index]] === "" && index > 0) {
                const prev = document.querySelector(`#otp${index}`);
                prev && prev.focus();
            }
        },
        checkInput() {
            const _this = this;
            console.log("checkInput");

            if (_this.nowStep === "personalInfo") {
                if (!_this.inputData.isRead) {
                    alert("請確認是否已詳閱並同意相關使用須知");
                    return;
                }

                const validMobile = /^09\d{8}$/;
                if (!validMobile.test(_this.inputData.phone)) {
                    alert("請確認行動電話格式");
                    return;
                }

                _this.getOTP();
                return;
            }

            if (_this.nowStep === "messageOTP") {
                _this.inputData.otp = "";
                // for (let i = 0; i <= 5; i++) {
                //     _this.inputData.otp += _this.inputData[`otp${i}`] || "";
                // }
                _this.inputData.otp = _this.inputData.otp1 + _this.inputData.otp2 + _this.inputData.otp3 + _this.inputData.otp4 + _this.inputData.otp5;
                console.log(_this.inputData.otp);

                if (_this.inputData.otp.length !== 5) {
                    _this.isWrong = true;
                    return;
                }

                _this.verifyOTP();
                return;
            }

            if (_this.nowStep === "signUp") {
                if (!_this.inputData.name || _this.inputData.name === "") {
                    alert("請輸入姓名");
                    return;
                }

                if (_this.inputData.gender === "") {
                    alert("請選擇性別");
                    return;
                }

                if (!_this.inputData.birthday || _this.inputData.birthday === "") {
                    alert("請選擇生日");
                    return;
                }

                const min = '1900-01-01'
                const max = new Date().toISOString().split('T')[0]
                if (_this.inputData.birthday < min || _this.inputData.birthday > max) {
                    alert('請輸入有效的出生日期（需介於 1900 年至今日之間）。')
                    _this.inputData.birthday = '';
                    return;
                }

                _this.inputData.dateReplace = _this.inputData.birthday.replace(/-/g, "/");
                _this.sendSignUp();
            }
        },
        startCountdown() {
            const _this = this;
            const duration = 3 * 60;
            let timer = duration;
            const interval = setInterval(function () {
                _this.minutes = Math.floor(timer / 60);
                _this.seconds = timer % 60;
                if (--timer < 0) {
                    clearInterval(interval);
                    _this.isWrong = true;
                }
            }, 1000);
            _this.timerArr.push(interval);
        },
        getOTP() {
            console.log("getOTP");
            const _this = this;

            _this.isLock = true;
            _this.isWrong = false;
            _this.timerArr.forEach(timer => clearInterval(timer));

            for (let i = 1; i <= 5; i++) {
                _this.inputData[`otp${i}`] = "";
            }
            _this.inputData.otp = "";
            _this.startCountdown();

            const data = {
                phone: _this.inputData.phone,
            };

            axios
                .post(`${_this.hostUrl}binding/otp/send`, data)
                .then(response => {
                    console.log(response);
                    if (response.status === 200) {
                        _this.isLock = false;
                        nextTick(() => {
                            _this.nowStep = "messageOTP";
                        });
                    }
                })
                .catch(error => {
                    if (error.response.status === 400) {
                        if (error.response.data.error === "40001") {
                            _this.isBind = true;
                        }else if(error.response.data.error === "40003"){
                            _this.error03 = true;
                        }
                    } else {
                        alert("伺服器忙碌中，請稍後再試");
                    }
                    console.log(error);
                });
        },
        verifyOTP() {
            console.log("verifyOTP");
            const _this = this;

            _this.isLock = true;
            _this.isWrong = false;

            const data = {
                phone: _this.inputData.phone,
                otp: _this.inputData.otp,
            };

            axios
                .post(`${_this.hostUrl}binding/otp/verify`, data)
                .then(response => {
                    console.log(response);
                    if (response.status === 200) {
                        if (response.data.member !== null) {
                            _this.isMember = true;
                            const { birthday, gender, name, email } = response.data.member;
                            if(birthday !== null){
                                _this.inputData.birthday = birthday.replace(/\//g, "-");
                                _this.birthdayLock = true
                            }
                            if(gender !== null){
                                _this.inputData.gender = gender;
                            }
                            if(name !== null){
                                _this.inputData.name = _this.removeLineBreaks(name);
                            }
                            if(email !== ''){
                                _this.inputData.email = email;
                            }
                        }

                        nextTick(() => {
                            _this.nowStep = "signUp";
                            _this.isBind = false;
                            _this.isWrong = false;
                        });
                    }
                })
                .catch(error => {
                    _this.isLock = false;
                    if (error.response.status === 400) {
                        if (error.response.data.error === "40002") {
                            _this.isWrong = true;
                        }
                    } else {
                        alert("伺服器忙碌中，請稍後再試");
                    }
                    console.log(error);
                });
        },
        sendSignUp() {
            console.log("sendSignUp");
            const _this = this;
            _this.$store.commit("loadingToggle", true);
            _this.isLock = true;

            const data = {
                lineUid: _this.userLineInfo.userId,
                phone: _this.inputData.phone,
                name: _this.inputData.name,
                birthday: _this.inputData.birthday.replace(/-/g, "/"),
                gender: _this.inputData.gender,
                email: _this.inputData.email
            };

            axios
                .post(`${_this.hostUrl}binding/register`, data)
                .then(response => {
                    console.log(response);

                    if (response.status === 200) {
                        nextTick(() => {
                            _this.$store.dispatch("userLogin");
                        });
                    }
                })
                .catch(error => {
                    _this.isLock = false;
                    if (error.response.status === 400) {
                        if (error.response.data.error === "40002") {
                            _this.isWrong = true;
                        }
                    } else {
                        alert("伺服器忙碌中，請稍後再試");
                    }
                    console.log(error);
                });
        },
        validateEmail() {
            if (!this.inputData.email) return

            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

            if (!regex.test(this.inputData.email)) {
                alert('Email 格式不正確')
                this.inputData.email = ''
            }
        },
        limitWidth10() {
            const _this = this;
            let val = _this.inputData.name;
            let width = 0;
            let result = '';

            val = _this.removeLineBreaks(val)

            for (let ch of val) {
                const size = this.isHalfWidth(ch) ? 1 : 2;

                if (width + size > 10) break;

                width += size;
                result += ch;
            }

            _this.inputData.name = result;
        },
        isHalfWidth(ch) {
            return ch.codePointAt(0) <= 0x7F;
        },
        removeLineBreaks(str) {
            // 移除換行字元
            return str.replace(/[\r\n]+/g, '');
        },
        testInput(){
            console.log([...this.inputData.name].map(c => c.charCodeAt(0)))
        }
    },
};
</script>

<template src="./template.pug" lang="pug"></template>

<style src="./style.sass" lang="sass" scoped></style>
